import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LaaSSharedModule } from 'src/app/shared/laas-shared.module';
import { DetailIssuablePipe } from 'src/app/shared/pipes/detail-issuable.pipe';
import { StsFlagMappingPipe } from 'src/app/shared/pipes/sts-flag-mapping.pipe';
import { MultiFactorAuthComponent } from '../integration-auth/multi-factor-auth/multi-factor-auth.component';
import { AccountActivationReminderComponent } from '../setting/pages/account-activation-reminder/account-activation-reminder.component';
import { ForgotPasswordComponent } from '../setting/pages/forgot-password/forgot-password.component';
import { TenantMappingUserGroupDetailDialogComponent } from '../system-setting/page/tenant-mapping-user-group-detail-dialog/tenant-mapping-user-group-detail-dialog.component';
import { CarTypeSelectorComponent } from './components/car-type-selector/car-type-selector.component';
import { CheckControlledItemComponent } from './components/check-controlled-item/check-controlled-item.component';
import { DoMergeComponent } from './components/do-merge/do-merge.component';
import { DoScanImportComponent } from './components/do-scan-import/do-scan-import.component';
import { DoSearchImportComponent } from './components/do-search-import/do-search-import.component';
import { DropCtnModiyComponent } from './components/drop-ctn-modiy/drop-ctn-modiy.component';
import { FileManagementComponent } from './components/file-management/file-management.component';
import { FrontlineDocumentComponent } from './components/frontline-document/frontline-document.component';
import { HSCodeSelectorComponent } from './components/hscode-selector/hscode-selector.component';
import { OrphanContainerComponent } from './components/orphan-container/orphan-container.component';
import { ShippingNotesComponent } from './components/shipping-notes/shipping-notes.component';
import { TermsSelectorComponent } from './components/terms-selector/terms-selector.component';
import { AdvisingAbnormalComponent } from './pages/advising-abnormal/advising-abnormal.component';
import { AllocationConstraintComponent } from './pages/allocation-constraint/allocation-constraint.component';
import { AllocationConstraintInboundComponent } from './pages/allocation-constraint-inbound/allocation-constraint-inbound.component';
import { AutoprintReprintComponent } from './pages/autoprint-reprint/autoprint-reprint.component';
import { BatchUpdateBookingComponent } from './pages/batch-update-booking/batch-update-booking.component';
import { BookingArriveComponent } from './pages/booking-arrive/booking-arrive.component';
import { BookingHeaderDetailComponent } from './pages/booking-header-detail/booking-header-detail.component';
import { BookingHeaderEditRelatedBillComponent } from './pages/booking-header-edit-related-bill/booking-header-edit-related-bill.component';
import { BookingHeaderEditComponent } from './pages/booking-header-edit/booking-header-edit.component';
import { BookingSearchForForwarderHeaderDetailComponent } from './pages/booking-search-for-forwarder-header-detail/booking-search-for-forwarder-header-detail.component';
import { BookingSearchForForwarderHeaderEditComponent } from './pages/booking-search-for-forwarder-header-edit/booking-search-for-forwarder-header-edit.component';
import { BookingSearchForForwarderComponent } from './pages/booking-search-for-forwarder/booking-search-for-forwarder.component';
import { BookingSearchComponent } from './pages/booking-search/booking-search.component';
import { BillingPreviewCalculateComponent } from './pages/booking-search/components/billing-preview-calculate/billing-preview-calculate.component';
import { BillingViewerComponent } from './pages/booking-search/components/billing-viewer/billing-viewer.component';
import { BookingDetailPickupChangeComponent } from './pages/booking-search/components/booking-detail-pickup-change/booking-detail-pickup-change/booking-detail-pickup-change.component';
import { BookingDetailStatusChangeComponent } from './pages/booking-search/components/booking-detail-status-change/booking-detail-status-change.component';
import { CertificateDownloadComponent } from './pages/booking-search/components/certificate-download/certificate-download.component';
import { ErrorTmsComponent } from './pages/booking-search/components/error-tms/error-tms.component';
import { RedeliveryBookingComponent } from './pages/booking-search/components/redelivery-booking/redelivery-booking.component';
import { ReturnTmsComponent } from './pages/booking-search/components/return-tms/return-tms.component';
import { RtnDeliveryRemarkComponent } from './pages/booking-search/components/rtn-delivery-remark/rtn-delivery-remark.component';
import { RtnWhRemarkComponent } from './pages/booking-search/components/rtn-wh-remark/rtn-wh-remark.component';
import { SerialpdaRemarkComponent } from './pages/booking-search/components/serialpda-remark/serialpda-remark.component';
import { UrgentRemarkComponent } from './pages/booking-search/components/urgent-remark/urgent-remark.component';
import { ChinaImportDeclarationReportComponent } from './pages/china-import-declaration-report/china-import-declaration-report.component';
import { ContainerManagementComponent } from './pages/container-management/container-management.component';
import { CreateDoComponent } from './pages/create-do/create-do.component';
import { CustomerSignatureSampleStampComponent } from './pages/customer-signature-sample-stamp/customer-signature-sample-stamp.component';
import { CustomsClearanceShippingReportComponent } from './pages/customs-clearance-shipping-report/customs-clearance-shipping-report.component';
import { DhlEditComponent } from './pages/dhl-edit/dhl-edit.component';
import { DoAbnormalComponent } from './pages/do-abnormal/do-abnormal.component';
import { DoDetailForShippingComponent } from './pages/do-detail-for-shipping/do-detail-for-shipping.component';
import { DoDetailComponent } from './pages/do-detail/do-detail.component';
import { DoSearchForShippingComponent } from './pages/do-search-for-shipping/do-search-for-shipping.component';
import { DoSearchComponent } from './pages/do-search/do-search.component';
import { ExportHeaderAddComponent } from './pages/export-header-add/export-header-add.component';
import { ExportHeaderDetailComponent } from './pages/export-header-detail/export-header-detail.component';
import { ExportHeaderEditComponent } from './pages/export-header-edit/export-header-edit.component';
import { ExportSearchComponent } from './pages/export-search/export-search.component';
import { ForwarderCooperationComponent } from './pages/forwarder-cooperation/forwarder-cooperation.component';
import { ShipTermDescriptionComponent } from './pages/forwarder-cooperation/shipterm-description/shipterm-description.component';
import { FreightSearchComponent } from './pages/freight-search/freight-search.component';
import { FreightTrialCalculationComponent } from './pages/freight-trial-calculation/freight-trial-calculation.component';
import { ImportHeaderDetailComponent } from './pages/import-header-detail/import-header-detail.component';
import { ImportHeaderEditComponent } from './pages/import-header-edit/import-header-edit.component';
import { ImportSearchComponent } from './pages/import-search/import-search.component';
import { InOutWarehousingComponent } from './pages/in-out-warehousing/in-out-warehousing.component';
import { InboundProgressComponent } from './pages/inbound-progress/inbound-progress.component';
import { IntransitImportComponent } from './pages/intransit-update/intransit-import/intransit-import.component';
import { IntransitUpdateComponent } from './pages/intransit-update/intransit-update.component';
import { LeaveWarehouseComponent } from './pages/leave-warehouse/leave-warehouse.component';
import { ManualAllocationWMSComponent } from './pages/manual-allocation/manual-allocation-wms/manual-allocation-wms.component';
import { ManualAllocationComponent } from './pages/manual-allocation/manual-allocation.component';
import { MaterialDocumentComponent } from './pages/material-document/material-document.component';
import { MergeKeySearchComponent } from './pages/merge-key-search/merge-key-search.component';
import { MixCartonSearchComponent } from './pages/mix-carton-search/mix-carton-search.component';
import { MSDCIQCComponent } from './pages/msdc-iqc/msdc-iqc.component';
import { MSDCSearchComponent } from './pages/msdc-search/msdc-search.component';
import { OverDcSearchComponent } from './pages/over-dc-search/over-dc-search.component';
import { PickingAssignmentComponent } from './pages/picking-assignment/picking-assignment.component';
import { PoConvertAdComponent } from './pages/po-search/po-convert-ad/po-convert-ad.component';
import { PoSearchComponent } from './pages/po-search/po-searchcomponent';
import { PurchaseSearchComponent } from './pages/purchase-search/purchase-search.component';
import { ReceivingInstructionBatchUpdateComponent } from './pages/receiving-instruction-batch-update/receiving-instruction-batch-update.component';
import { ReceivingInstructionComponent } from './pages/receiving-instruction/receiving-instruction.component';
import { RegistrationFormSearchComponent } from './pages/registration-form-search/registration-form-search.component';
import { RegistrationFormComponent } from './pages/registration-form/registration-form.component';
import { RegistrationImportComponent } from './pages/registration-form/registration-import/registration-import.component';
import { ShipmentProgessSearchComponent } from './pages/shipment-progess-search/shipment-progess-search.component';
import { ShipmentProgressComponent } from './pages/shipment-progress/shipment-progress.component';
import { WarehousingAbnormalHandlingForPcsrComponent } from './pages/warehousing-abnormal/warehousing-abnormal-handling-for-pcsr/warehousing-abnormal-handling-for-pcsr.component';
import { WarehousingAbnormalHistoryComponent } from './pages/warehousing-abnormal/warehousing-abnormal-history/warehousing-abnormal-history.component';
import { WarehousingAbnormalTrackingForShippingComponent } from './pages/warehousing-abnormal/warehousing-abnormal-tracking-for-shipping/warehousing-abnormal-tracking-for-shipping.component';
import { WarehousingAbnormalComponent } from './pages/warehousing-abnormal/warehousing-abnormal.component';
import { WarehousingCreationComponent } from './pages/warehousing-creation/warehousing-creation.component';
import { WarehousingUploadComponent } from './pages/warehousing-creation/warehousing-upload/warehousing-upload.component';
import { WarehousingEditRelatedBillComponent } from './pages/warehousing-edit-related-bill/warehousing-edit-related-bill.component';
import { WarehousingEditComponent } from './pages/warehousing-edit/warehousing-edit.component';
import { WarehousingHeaderDetailComponent } from './pages/warehousing-header-detail/warehousing-header-detail.component';
import {SettingModule} from '../setting/setting.module';
import {SelectButtonModule} from 'primeng/selectbutton';
import { AssignWarehousingComponent } from './pages/warehousing-search/assign-warehousing/assign-warehousing.component';
import { CopyWarehousingComponent } from './pages/warehousing-search/copy-warehousing/copy-warehousing.component';
import { WarehousingRmbPriceImportComponent } from './pages/warehousing-search/warehousing-rmb-price-import/warehousing-rmb-price-import.component';
import { WarehousingSearchComponent } from './pages/warehousing-search/warehousing-search.component';
import { TransportOperationRoutingModule } from './transport-operation-routing.module';
import { AsnInfoSearchComponent } from '../setting/pages/asn-info-search/asn-info-search.component';
import { CreateContainerComponent } from '../setting/pages/create-container/create-container.component';
import { VmiAdvisingComponent } from './pages/vmi-advising/vmi-advising.component';
import { VmiDOCreateComponent } from './pages/vmi-do-create/vmi-do-create.component';
import { RemainingSkuComponent } from '../component/remaining-sku/remaining-sku.component';
import { TruckCostAllocationComponent } from './pages/truck-cost-allocation/truck-cost-allocation.component';
import { CreateCrossBoundryComponent } from './pages/create-cross-boundry/create-cross-boundry.component';
import { ImportCrossBoundryComponent } from './pages/import-cross-boundry/import-cross-boundry.component';
import { ForwarderEditComponent } from './pages/forwarder-edit/forwarder-edit.component';
import { FrontlineDocomentReturnConfirmDialogComponent } from './components/frontline-docoment-return-confirm-dialog/frontline-docoment-return-confirm-dialog.component';
import { CustomerLabelComponent } from './pages/customer-label/customer-label.component'
import { IQCStatusSearchComponent } from './pages/iqc-status-search/iqc-status-search.component';

@NgModule({
  declarations: [
    DoSearchComponent,
    DoDetailComponent,
    DoSearchForShippingComponent,
    BookingSearchComponent,
    BookingSearchForForwarderComponent,
    BookingHeaderEditComponent,
    BookingHeaderDetailComponent,
    PickingAssignmentComponent,
    ExportSearchComponent,
    ContainerManagementComponent,
    ExportHeaderDetailComponent,
    ExportHeaderEditComponent,
    ExportHeaderAddComponent,
    RtnWhRemarkComponent,
    RtnDeliveryRemarkComponent,
    UrgentRemarkComponent,
    CertificateDownloadComponent,
    ReturnTmsComponent,
    DhlEditComponent,
    BookingSearchForForwarderHeaderDetailComponent,
    LeaveWarehouseComponent,
    ErrorTmsComponent,
    BookingDetailStatusChangeComponent,
    ImportSearchComponent,
    ErrorTmsComponent,
    BookingSearchForForwarderHeaderEditComponent,
    ImportHeaderDetailComponent,
    ImportHeaderEditComponent,
    WarehousingCreationComponent,
    WarehousingSearchComponent,
    AssignWarehousingComponent,
    CopyWarehousingComponent,
    WarehousingEditComponent,
    BillingViewerComponent,
    WarehousingUploadComponent,
    WarehousingHeaderDetailComponent,
    WarehousingRmbPriceImportComponent,
    BillingPreviewCalculateComponent,
    BatchUpdateBookingComponent,
    ReceivingInstructionComponent,
    InOutWarehousingComponent,
    MergeKeySearchComponent,
    CustomerSignatureSampleStampComponent,
    ShipmentProgressComponent,
    FreightTrialCalculationComponent,
    AdvisingAbnormalComponent,
    ShipmentProgessSearchComponent,
    PurchaseSearchComponent,
    SerialpdaRemarkComponent,
    DoAbnormalComponent,
    ForwarderCooperationComponent,
    InboundProgressComponent,
    PurchaseSearchComponent,
    ShipTermDescriptionComponent,
    FreightSearchComponent,
    BookingArriveComponent,
    WarehousingEditRelatedBillComponent,
    BookingHeaderEditRelatedBillComponent,
    ReceivingInstructionBatchUpdateComponent,
    DoDetailForShippingComponent,
    IntransitUpdateComponent,
    IntransitImportComponent,
    BookingDetailPickupChangeComponent,
    RegistrationFormSearchComponent,
    RegistrationFormComponent,
    RegistrationImportComponent,
    AutoprintReprintComponent,
    RedeliveryBookingComponent,
    PoSearchComponent,
    PoConvertAdComponent,
    MaterialDocumentComponent,
    WarehousingAbnormalComponent,
    ChinaImportDeclarationReportComponent,
    CustomsClearanceShippingReportComponent,
    DoScanImportComponent,
    DoSearchImportComponent,
    DropCtnModiyComponent,
    CarTypeSelectorComponent,
    CheckControlledItemComponent,
    OrphanContainerComponent,
    DoMergeComponent,
    FileManagementComponent,
    FrontlineDocumentComponent,
    HSCodeSelectorComponent,
    TenantMappingUserGroupDetailDialogComponent,
    TermsSelectorComponent,
    AccountActivationReminderComponent,
    ForgotPasswordComponent,
    MultiFactorAuthComponent,
    OverDcSearchComponent,
    MSDCIQCComponent,
    MSDCSearchComponent,
    ManualAllocationComponent,
    ManualAllocationWMSComponent,
    CreateDoComponent,
    StsFlagMappingPipe,
    DetailIssuablePipe,
    MixCartonSearchComponent,
    AllocationConstraintComponent,
    AllocationConstraintInboundComponent,
    CreateContainerComponent,
    WarehousingAbnormalHandlingForPcsrComponent,
    AsnInfoSearchComponent,
    ShippingNotesComponent,
    WarehousingAbnormalTrackingForShippingComponent,
    WarehousingAbnormalHistoryComponent,
    AsnInfoSearchComponent,
    VmiAdvisingComponent,
    RemainingSkuComponent,
    FrontlineDocomentReturnConfirmDialogComponent,
    TruckCostAllocationComponent,
    CreateCrossBoundryComponent,
    ImportCrossBoundryComponent,
    VmiDOCreateComponent,
    RemainingSkuComponent,
    ForwarderEditComponent,
    CustomerLabelComponent,
    IQCStatusSearchComponent,
  ],
    imports: [
    TransportOperationRoutingModule,
    LaaSSharedModule,
    CommonModule,
    SettingModule,
    SelectButtonModule,
  ],
  exports: [
    LaaSSharedModule,
    DoScanImportComponent,
    DoSearchImportComponent,
    DropCtnModiyComponent,
    CarTypeSelectorComponent,
    CheckControlledItemComponent,
    OrphanContainerComponent,
    DoMergeComponent,
    FileManagementComponent,
    FrontlineDocumentComponent,
    TenantMappingUserGroupDetailDialogComponent,
    HSCodeSelectorComponent,
    TermsSelectorComponent,
    AccountActivationReminderComponent,
    ForgotPasswordComponent,
    MultiFactorAuthComponent
  ]
})
export class TransportOperationModule { }
